<template>
  <TheMenuLayout>
    <BaseSectionHeader>
      {{$t('Marks')}} - {{ semester }}
    </BaseSectionHeader>
    <v-row class="mb-2">
      <v-col>
        <BaseNumberCard color="accent lighten-3" :title="$t('General ranking')">
          {{ evaluations.rank }}/{{ evaluations.number_of_students }}
        </BaseNumberCard>
      </v-col>
      <v-col>
        <BaseNumberCard v-if="evaluations.average_mark" color="accent lighten-3" :title="$t('Average mark')">
          {{ evaluations.average_mark.toLocaleString(undefined, { maximumFractionDigits: 2 }) }}/20
        </BaseNumberCard>
      </v-col>
    </v-row>

    <v-divider class="mb-4" />

    <BaseSectionHeader>
      {{ $t('Details') }}
    </BaseSectionHeader>

    <v-row v-if="evaluations">
      <v-col
        cols="12"
        xl="6"
        v-for="evaluation in evaluations.evaluations"
        :key="evaluation.id"
      >
        <v-card
          outlined
          color="grey lighten-3"
        >
          <v-row class="pl-2">
            <v-col cols="5">
              <small class="font-weight-bold">
                {{ evaluation.exam.subject.name }}
              </small>
              <br>
              <v-row>
                <v-col cols="4">
                  <small>{{ $t('Coefficient') }} : {{ evaluation.exam.coefficient }}</small>
                </v-col>
                <v-col cols="4">
                  <small>{{ $t('Max') }} : {{ evaluation.exam.max_mark }}</small>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <small>{{ $t('Min') }} : {{ evaluation.exam.min_mark }}</small>
                </v-col>
                <v-col cols="4">
                  <small>{{ $t('Moy.') }} : {{ Math.round(evaluation.exam.average_mark * 100) / 100 }}</small>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="4" class="text-center">
              <small class="text-uppercase">Classement</small>
              <br>
              <small class="font-weight-bold">
                {{ evaluation.rank }}
              </small>
            </v-col>
            <v-col cols="3" class="text-center">
              <small class="text-uppercase">Note</small>
              <br>
              <small class="font-weight-bold">
                {{ evaluation.mark }}/20
              </small>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </TheMenuLayout>
</template>

<script>
import {
  mapState, mapActions, mapGetters, mapMutations,
} from 'vuex';

import BaseSectionHeader from '@/components/BaseSectionHeader.vue';
import TheMenuLayout from '@/components/TheMenuLayout.vue';
import BaseNumberCard from '@/components/BaseNumberCard.vue';

export default {
  name: 'Evaluations',
  components: {
    BaseSectionHeader,
    TheMenuLayout,
    BaseNumberCard,
  },
  created() {
    const { semester } = this.$route.query;
    if (!semester) {
      this.$router.push('/notes');
    }
    this.setSemester(semester);
    this.fetchEvaluations(semester).catch((error) => {
      if (error.response.status === 404 || error.response.status === 400) {
        this.$router.push('/notes');
      }
    });
  },
  computed: {
    ...mapState(['evaluations', 'semester']),
    ...mapGetters(['availableSemesters']),
  },
  methods: {
    ...mapActions(['fetchEvaluations']),
    ...mapMutations(['setSemester']),
  },
};
</script>
